import { userInfoSync } from 'hub-http/userInfo';
import { gate } from 'hub-http/gates';
const BU_ACCESS_SCOPE = 'business-units-access';
const DOCUMENTS_MULTIBRAND_GATE = gate('BuyerExperience:SalesDocumentsMultiBrand');
export default (() => {
  const auth = userInfoSync();
  return Boolean(auth.user.scopes.includes(BU_ACCESS_SCOPE) && auth.gates.includes(DOCUMENTS_MULTIBRAND_GATE));
});